<script setup>
import { onMounted, ref } from 'vue'
import { Eye, Images, UserCheck, Users } from 'lucide-vue-next'
import api from '../services/api'
import PageHeader from '../components/PageHeader.vue'
const data=ref({metrics:{}}),loading=ref(true)
const cards=[['pendingUsers','待审核员工',Users,'amber'],['approvedUsers','在职执行人员',UserCheck,'green'],['pendingCases','待复核案例',Images,'blue'],['publicCases','公开案例',Eye,'violet']]
onMounted(async()=>{try{data.value=await api.call('dashboard')}finally{loading.value=false}})
</script>
<template><PageHeader title="数据概览" description="查看当前员工与案例状态"><span v-if="api.isMock" class="mode-badge">本地演示模式</span></PageHeader><div class="metric-grid"><article v-for="[key,label,icon,color] in cards" :key="key" class="metric-card"><div class="metric-icon" :class="color"><component :is="icon" :size="22"/></div><div><strong>{{loading?'--':data.metrics[key]}}</strong><span>{{label}}</span></div></article></div></template>
